var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0846 21.5329V11.6088C19.4959 11.8312 18.8577 11.9529 18.1912 11.9529H18.1885V19.6368H4.91608V6.3644H12.837C12.8653 5.69306 13.017 5.05366 13.2702 4.46834H3.02002V21.5329H20.0846Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81215 18.1337H8.70821V16.2377H6.81215V18.1337Z",
    fill: "#9CA3AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81215 14.3416H8.70821V12.4456H6.81215V14.3416Z",
    fill: "#9CA3AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6043 18.1337H16.2925V16.2377H10.6043V18.1337Z",
    fill: "#9CA3AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6043 14.3416H16.2925V12.4456H10.6043V14.3416Z",
    fill: "#9CA3AF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8174 8.05172H16.5421V6.24017H15.8174V8.05172Z",
    fill: "#9CA3AF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1797 9.13864C16.2824 9.13864 16.3685 9.10392 16.4379 9.03448C16.5073 8.96504 16.5421 8.87899 16.5421 8.77634C16.5421 8.67368 16.5073 8.58763 16.4379 8.51819C16.3685 8.44875 16.2824 8.41403 16.1797 8.41403C16.0771 8.41403 15.991 8.44875 15.9216 8.51819C15.8522 8.58763 15.8174 8.67368 15.8174 8.77634C15.8174 8.87899 15.8522 8.96504 15.9216 9.03448C15.991 9.10392 16.0771 9.13864 16.1797 9.13864Z",
    fill: "#9CA3AF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1807 2.4668L11.3821 10.7781H20.9792L16.1807 2.4668ZM16.1807 4.94565L18.8325 9.53872H13.5289L16.1807 4.94565Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorDashboard);
export default __webpack_public_path__ + "static/media/Error Dashboard.3bb507bd2c4d3bcacdfff7dd03cd6dea.svg";
export { ForwardRef as ReactComponent };